<template>
  <div class="svj-scheme" ref="scheme" :style="baseSizeVariable" :class="{'svj-scheme--no-croll': modalVisible}">
    <category-list
      :option="option"
      @init="initCategory"
      @change="chooseCategory"
      :categoryApi="categoryApi"
      ref="categoryList"
    ></category-list>
    <div class="svj-scheme__list">
      <scheme-card
        v-for="(scheme, index) in schemeList"
        :key="`${scheme.schemeId}-${index}`"
        :scheme="scheme"
        @showDetail="showDetail(scheme)"
      ></scheme-card>
    </div>
    <detail-modal-mobile :container="$refs.scheme" :detail="modalDetail" v-model="modalVisible" ref="modalDetail"></detail-modal-mobile>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import request from '@/utils/request';
import '@/styles/mixins/text.less';
import { throttle } from '@/utils/help';
import SchemeCard from './Card.vue';
import CategoryList from './CategoryList.vue';
import DetailModalMobile from './DetailModalMobile.vue';


const requestInstance = request();

export default {
  name: 'SchemeListMobile',
  props: {
    categoryApi: {
      required: true,
      type: String,
    },
    schemeApi: {
      required: true,
      type: String,
    },
    option: {
      required: true,
      type: Object,
    },
    baseSize: {
      required: false,
      type: String,
    },
  },
  components: {
    SchemeCard,
    CategoryList,
    DetailModalMobile,
  },
  data() {
    return {
      schemeList: [],
      chosenCategory: {},
      pageSize: 9,
      schemeCount: 9,
      pageIndex: 1,
      modalVisible: false,
      modalDetail: {},
      showLoading: false,
      isBusy: false,
      hasScrollEvent: false,
      scrollEvent: null,
      parentNode: null,
      bottom: 0,
    };
  },
  computed: {
    baseSizeVariable() {
      if (this.baseSize) {
        return {
          '--svj-base-size': this.baseSize,
        };
      }
      return {};
    },
  },
  mounted() {
    this.parentNode = this.$refs.scheme.parentNode;
    this.scrollEvent = throttle(this.handleScroll, 200);
    this.init();
  },
  beforeDestroy() {
    this.unbindScrollEvent();
  },
  methods: {
    showDetail(scheme) {
      this.modalVisible = true;
      this.modalDetail = scheme;
    },
    toPage() {
      this.getScheme({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      });
    },
    async init() {
      if (this.option.category) {
        await this.$refs.categoryList.getCategory();
      }
      this.$refs.categoryList.initCategory(false);

      this.unbindScrollEvent();
      if (this.hasScrollEvent === false) {
        this.hasScrollEvent = true;
        this.bindScrollEvent();
      }

      // 每行方案数固定1
      this.pageIndex = 1;
      this.pageSize = this.option.schemeRow;
      this.getScheme();
    },
    bindScrollEvent() {
      const parentEle = this.parentNode;
      this.bottom = parentEle.getBoundingClientRect().bottom;
      this.parentNode.addEventListener('scroll', this.scrollEvent);
    },
    unbindScrollEvent() {
      this.hasScrollEvent = false;
      this.parentNode.removeEventListener('scroll', this.scrollEvent);
    },
    handleScroll() {
      const {
        bottom: contentBottom,
      } = this.$refs.scheme.getBoundingClientRect();
      // 2 为浏览器误差
      if (this.bottom + 2 >= contentBottom) {
        this.addSchemes();
      }
    },
    addSchemes() {
      if (!this.isBusy) {
        this.showLoading = true;
        this.isBusy = true;
        this.pageIndex += 1;
        this.getScheme();
      }
    },
    getScheme(param) {
      const mixedParam = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        CustomTag: [],
      };
      Object.keys(this.chosenCategory).forEach(key => {
        if (/^CustomTag/.test(key)) {
          mixedParam.CustomTag.push(this.chosenCategory[key]);
        } else {
          mixedParam[key] = this.chosenCategory[key];
        }
      });

      if (typeof param === 'object') {
        Object.assign(mixedParam, param);
      }

      requestInstance
        .post(this.schemeApi, mixedParam)
        .then((res) => {
          if (res.success && res.result) {
            if (this.pageIndex * this.pageSize <= res.result.recordCount) {
              this.isBusy = false;
            } else {
              this.isBusy = true;
            }
            this.showLoading = false;
            if (this.pageIndex === 1) {
              this.schemeList = res.result.result;
            } else {
              this.schemeList = this.schemeList.concat(res.result.result);
            }
          }
        })
        .catch((err) => {
          this.$emit('handleError', err);
        });
    },
    initCategory(typeObj) {
      this.chosenCategory = typeObj;
    },
    chooseCategory(typeObj) {
      this.chosenCategory = typeObj;
      this.pageIndex = 1;
      this.getScheme();
    },
  },
};
</script>

<style lang="less">
.svj-scheme {
  .cursor-pointer {
    cursor: pointer;
  }
}
</style>
<style lang="scss" scoped>
@import "../../../styles/mixins/mobile.scss";

.svj-scheme {
  --svj-base-size: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #FAFAFA;
  padding-top: vw(20);
  .svj-scheme__list {
    width: vw(335);
    margin-bottom: vw(20);
  }
}
.svj-scheme--no-croll {
  position: relative;
  height: 100%;
  overflow: hidden;
}
</style>
